module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-1-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("D")]), _vm._v("S Edd Carter walked in ahead of his daughter to make sure there was nothing damaging on the evidence board. He’d managed to give Emily a tour of the station without her seeing anything she shouldn’t; he didn’t want his own office space to be the spot that ruined it. He felt a pang of relief when he stepped in and saw the board was blank, presumably waiting for fresh material. But whatever the reason, it made this room a safe space. Emily had never been to the office and it was one of the many things he’d promised her to soften the blow of a boring half-term.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘And this is where I work,’ he said, by way of alerting his colleagues to their arrival.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Emily looked around the room with awe. ‘So, you hunt bad guys down from here?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Well, your dad doesn’t do much of that, but we do,’ DC David Read replied, crossing the room with a smile. He crouched to be eye-to-eye with Emily, held out a hand and said, ‘I’m David, that’s Brian.’ He nodded behind him to his partner, who waved.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Emily took his hand with a confidence that looked strange on a child. ‘It’s nice to meet you, David and Brian. Who’s everyone else?’ She scoured the office then, her eyes soon landing on DC Chris Burton. ‘Chris!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Burton joined the huddle forming in the centre of the room. ‘Young lady. How are we?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Emily shrugged. ‘Okay, I guess. But I wish Dad didn’t have to work.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But I have to catch bad guys, right?’ He knelt to speak to his daughter directly. ‘I have to be here, and you have to be with Mum, but I’ll get you as soon as work is over. Deal?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Spit deal?’ she said, looking from her hand to his.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, Em, we talked about that.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The door jolted open with a force that grabbed everyone’s attention, and in walked DI Melanie Watton. She was juggling her phone against her ear, a full file of paperwork in one hand, and a to-go coffee mug in the other.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s good that you’ve called us, really,’ she said, walking past the group. ‘It doesn’t sound like your basic robbery to me either.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Melanie,’ Emily whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I think it’s best if I get a couple of officers down there…’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Melanie headed towards her office without a word, and Emily’s disappointment was clear. Carter was still level with his daughter, and he placed a finger under her chin to guide her face to his, and away from the closed office door. He kissed her nose lightly. ‘Mel is always happy to have visitors, but she’s a really busy lady.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Emily’s lips were downturned at the edges. ‘I do understand, Dad.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Shall we go and see if Mum’s here?’ he asked, and Emily nodded in reply. He stood up and tried to straighten out the beginnings of creases in his trousers. ‘Trish is coming to pick her up from the main office, so we’ll head down. If it’s anything especially interesting will you ask her to hang fire for a second?’ Carter said, his eyes shifting from one colleague to another.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Read rubbed at the back of his neck. ‘Sure, I’ll be the one to ask her.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Good man.’ Burton punched his arm gently. ‘Nice to see you, Emily.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Nice to see you all,’ she spoke to the group as Carter guided her towards the exit.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Melanie stepped out of her office to find the shared space in a state of calm. Read and Fairer were talking among themselves, a splay of paperwork taking up their desks, while Burton was furiously tapping at her keyboard. Melanie looked around again for the missing officers and noted that DC Lucy Morris’ desk looked untouched, though it was well into her morning shift. Melanie crossed the room to check the calendar to find out whatever it was that she’d forgotten this week.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Everything all right, boss?’ Burton took a pause from her typing.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Melanie turned. ‘Morris?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Half day.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘On a course?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘With the tech team.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Melanie frowned. ‘Do you think they’re going to pinch her?’ The question was only half-serious, but it was a thought that had crossed Melanie’s mind frequently since their last murder investigation. Morris had been integral to identifying their killer, and Melanie knew that people much higher up had noticed the DC’s performance.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Would you let them?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Would I hell.’ Melanie closed the gap between them. ‘Carter?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Taken Emily downstairs.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Bugger.’ Melanie breathed the word out in a harsh puff. ‘I wanted to say hello.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Cute kid, isn’t she?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘They all are at that age; give it time. We’ll wait for Carter to get back and then–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There was a clatter somewhere behind her and when she turned for the door she spotted Carter, leaning over with his hands on his knees. He looked to be out of breath but trying to gain some composure.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m here.’ He panted. ‘I’m here and I’m ready for robbery and– Christ, I’m unfit.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We’ll get started,’ Melanie addressed the team from the centre of the room. ‘We had a call come in this morning to report a murder-robbery on the outskirts of town. It looks as though whoever did this went all out on both the victim and the crime scene, quite a nasty one. Thousands of pounds-worth of artwork has gone missing.’ She took out a small sheet of paper from her trouser pocket, with the essentials scribbled on. Before she could introduce any further details, Carter took three strides across the room and nabbed the sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Burton and I will take that.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’ve recovered,’ Burton snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The victim’s name was Norman Halloway and he was a celebrated taxidermist,’ Melanie continued. She spotted the sudden change in Carter’s expression. ‘His home had a studio attached which is where he was found, and this is also where the artwork was taken from. Taxidermy is a pricey but particular business by all accounts so we’re looking for someone who knows their exotic animals, but also knows how to store them.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Carter held the sheet of paper out as though it were also a dead thing. ‘Taxidermy?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes. Problem?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He offered the sheet back to Melanie. ‘Hard pass, actually, Burton and I are swamped.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You called it,’ Melanie replied, her smile set in a smirk.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But when I called it–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Carter, let the woman speak,’ Burton interrupted. ‘You called it.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Melanie cocked an eyebrow at Carter and continued. ‘The artwork on site has to be stored and cleaned in a very specific way apparently. Halloway has, had, a cleaner who would come in every day to sort out the house, the studio and intermittently the pieces themselves. She turned up to work this morning to find the door to the studio wide open, went in to see that everything was okay, and that’s when she found her employer.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Definitely a murder?’ Fairer asked.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Hunting knife.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Read whistled. ‘Yep, definitely a murder.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How much has been taken?’ Burton asked, her pen hovering over a fresh sheet of paper.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We’re not entirely sure yet,’ Melanie replied. ‘The cleaner is in a bad way, although she’s trying to be co-operative. Part of that co-operation is identifying the empty spots in the studio. When I spoke to the call-out officers earlier she’d spotted around ten missing items but that could have changed by now.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s a lot of trouble just for ten,’ Read said.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I think we need to be prepared for that number to rise over the next few hours, as she notices more changes around the place. We also need to be especially vigilant with out-the-back deals going on right now. There’s a lot of money in taxidermy, but it isn’t going to be any old Joe on the street who’s looking to buy it. We’ll be dealing with some specialists along the way, I should think.’ Melanie turned to Carter. ‘Anything you need before you get going?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I mean, if there are already officers on site and investigating, what do we even need–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Anything you need before you get going?’ Melanie cut across Carter and craned around him, directing the question at Burton instead.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll take a less squeamish partner if there’s one kicking around.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Carter looked offended. ‘I am not squeamish.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So why don’t you want to go?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Because.’ He hesitated. ‘Okay, fine, because dead animals.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Burton stood from her desk and shrugged on her blazer. ‘Squeamish.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Carter held the sheet out for Burton to take and then stepped towards his own desk to grab his coat and his ID badge. ‘Burton, you’d be stuffed without me.’ There was a beat of silence while he looked from one colleague to another. ‘Come on, stuffed?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Very clever of you, Carter,’ Melanie said, her tone flat but her expression playful.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Bloody wasted in this office,’ he said, following his partner to the door. ‘Wasted…’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e09b994","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter001.vue
// module id = 87
// module chunks = 0